module.exports = __webpack_public_path__ + "static/media/Cecilia Bao.01eb7d6f.png";